export default __webpack_public_path__ + "static/media/direction.def9c60c.svg";